/**
 * Sidebar Module
 */

import { menus } from './data.js';

const state = {
    menus
}

const getters = {
    menus: state => {
        return state.menus;
    }
}

const actions = {
    
}

const mutations = {
    
}

export default {
    state,
    getters,
    actions,
    mutations
}